// Shared level icon for sensor alarms, following the AlarmsNotifications convention (RN8):
// INF = info notification, WAR = warning, ERR = error.
import { NotificationsActiveRounded, WarningRounded } from '@mui/icons-material'
import { normalizeLevel } from './sensorAlarmUtils'

export default function SensorLevelIcon ({ level, fontSize = 'small' }) {
  const normalised = normalizeLevel(level)
  if (normalised === 'INF') return <NotificationsActiveRounded fontSize={fontSize} color='info' />
  if (normalised === 'WAR') return <WarningRounded fontSize={fontSize} color='warning' />
  return <WarningRounded fontSize={fontSize} color='error' />
}
